import { render, staticRenderFns } from "./cont5.vue?vue&type=template&id=589d111e&scoped=true"
var script = {}
import style0 from "./cont5.vue?vue&type=style&index=0&id=589d111e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d111e",
  null
  
)

export default component.exports